import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { faTruckMoving } from '@fortawesome/free-solid-svg-icons/faTruckMoving';
import { Box, Typography } from '@mui/material';
import { ThemeProvider, styled, useTheme } from '@mui/material/styles';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntity } from 'app/entities/truck-implement/truck-implement.reducer';
import { NoImage } from 'app/shared/components/no-image/NoImage';
import { getSensorDataBySensorIdsAndTruckImplementId } from 'app/shared/reducers/shared/sensor-data-values.reducer';
import { isEmptyObject } from 'app/shared/util/functions-util';
import { Loading } from 'app/shared/util/loading';
import React, { useEffect } from 'react';
import { openFile } from 'react-jhipster';
import { RouteComponentProps } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import '../../../../dashboards/dashboard-truck-implement/components/truck-implement-info-tab/truckImplementInfo.scss';
import { reset } from '../../DashboardTruckImplement.reducer';
import { getOdometerByTruckImplementId, getOdometerSummaries } from 'app/shared/reducers/shared/truck-odometer.reducer';

export const TruckImplementInfo = ({ isModal, dataProps, ...props }: RouteComponentProps<{ id: string }> | any) => {
  const theme = useTheme();
  const dispatch = useAppDispatch();

  const [sensorDataValuesDTO] = useAppSelector(state => state.sensorDataValues.sensorDataValuesByTuckImplementIdDTO);
  const loadingSensorDataValues = useAppSelector(state => state.sensorDataValues.loading);
  const truckImplement = useAppSelector(state => state.truckImplement.entity);
  const loading = useAppSelector(state => state.truckImplement.loading);
  const truckOdometer = useAppSelector(state => state.truckOdometer.entity);
  const loadingTruckOdometer = useAppSelector(state => state.truckOdometer.loading);

  const truckSensorData = isEmptyObject(dataProps) ? sensorDataValuesDTO : dataProps;
  const themeVariant = theme.palette.mode === 'dark' ? true : false;
  const borderVariant = themeVariant ? '' : '2px solid #D5D5D5';
  const isPowerOn = truckSensorData?.isPowerOn;
  const outdated = truckSensorData?.outdated;
  const truckId = props.truckId;

  useEffect(() => {
    dispatch(reset());
    dispatch(getEntity(truckId));
    dispatch(getSensorDataBySensorIdsAndTruckImplementId({ truckImplementIds: [truckId], loadingSensorDataValues }));
    dispatch(getOdometerByTruckImplementId(truckId));
  }, [truckId]);

  const sectionValues = [
    {
      name: 'Total km',
      icon: faTruckMoving,
      value: !loadingTruckOdometer ? (
        truckOdometer?.totalOdometer ?? (
          <Typography fontSize={12} color="text.secondary" fontStyle="italic">
            Odômetro não encontrado
          </Typography>
        )
      ) : (
        <Spinner color="success" size="sm" />
      ),
    },
    // {
    //   name: 'Alertas',
    //   icon: faExclamationTriangle,
    //   value: !loadingSensorDataValues ? (
    //     truckSensorData?.totalAlertActivation + truckSensorData?.totalVirtualFenceCircleAlert || '-'
    //   ) : (
    //     <Spinner color="success" size="sm" />
    //   ),
    // },
  ];

  return !loading ? (
    <ThemeProvider theme={theme}>
      <BoxRow>
        {isModal ? (
          <></>
        ) : (
          <SpanPlate>
            <DivTruckPlate>
              <strong title={truckImplement.licensePlate}>{truckImplement.licensePlate || ''}</strong>
            </DivTruckPlate>
          </SpanPlate>
        )}
        <DivTruckImg sx={{ border: borderVariant }}>
          <BoxStatus>
            {!loadingSensorDataValues ? (
              <StatusButton
                sx={{
                  backgroundColor: isPowerOn && outdated ?  'status.main' : isPowerOn ? 'success.main' : 'error.main',
                  color: isPowerOn ? 'success.contrastText' : 'error.contrastText',
                  filter: truckImplement.activated === true ? 'none' : 'grayscale(100%)',
                }}
              >
                <small>{truckImplement.activated === true ? (isPowerOn && outdated ? 'Desatualizado' : isPowerOn ? 'Ligado' : 'Desligado') : 'Inativo'}</small>
              </StatusButton>
            ) : (
              <Spinner color="success" size="sm" />
            )}
          </BoxStatus>
          {truckImplement?.image ? (
            <Box component={'a'} width={'100%'} onClick={openFile('image/jpeg', truckImplement.image)}>
              <BoxImg src={`data:image/*;base64,${truckImplement.image}`} alt="imagem-implemento" />
            </Box>
          ) : (
            <NoImage />
          )}
        </DivTruckImg>
        <DivItemsDescription>
          {sectionValues.map((item, index) => (
            <DescriptionItem key={index} sx={{ border: borderVariant }}>
              <Typography fontSize={14} sx={{ whiteSpace: 'nowrap' }}>
                {item.name}
              </Typography>
              <Typography variant="subtitle1" fontWeight={600} mt={1}>
                {item.value}
              </Typography>
            </DescriptionItem>
          ))}
        </DivItemsDescription>
      </BoxRow>
    </ThemeProvider>
  ) : (
    <Loading />
  );
};

const BoxRow = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  marginBottom: '2px',
}));

const SpanPlate = styled('span')(({ theme }) => ({
  display: 'flex',
  width: '90%',
  height: '30px',
  marginTop: '24px',
  justifyContent: 'space-between',
  color: theme.palette.text.primary,
  [theme.breakpoints.down('md')]: {
    height: '10px',
  },
}));

const DivTruckPlate = styled('div')(({ theme }) => ({
  fontSize: '24px',
  lineHeight: '36px',
  [theme.breakpoints.down('xl')]: {
    fontSize: '20px',
  },
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

const DivTruckImg = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '90%',
  height: '200px',
  borderRadius: '8px',
  margin: '16px 10px 16px 10px',
  backgroundColor: theme.palette.background.default,
}));

const BoxImg = styled('img')(({ theme }) => ({
  bordeRadius: '15px 15px 0 0',
  maxWidth: '82vw',
  width: '100%',
  height: '200px',
  objectFit: 'cover',
  borderRadius: '8px',
  padding: '5px',
}));

const DivItemsDescription = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
  width: '90%',
  borderRadius: '8px',
  marginBottom: '16px',
}));

const DescriptionItem = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginTop: '5px',
  justifyContent: 'space-between',
  width: '48%',
  borderRadius: '8px',
  position: 'relative',
  left: '0',
  padding: '8px',
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.background.default,
}));

const StatusButton = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '4px 16px',
  gap: '4px',
  borderRadius: '8px',
  position: 'absolute',
  top: '0px',
  right: '0px',
}));

const BoxStatus = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '16px',
  right: '16px',
}));

export default TruckImplementInfo;
